import axios from 'axios';
import AppConfig from "../../../../../AppConfig";

let URL = AppConfig.HOST_API()+'ferie/';

export default {

    getFerie() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    addFerie(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editFerie(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deleteFerie(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/kalendarze/ferie/FerieService.js